import spiderman from '@/spiderman/index';

async function get(member) {
  return (
    await spiderman.axios.get(spiderman.api.motheringClasses, {
      headers: {
        jwt: member.jwt,
      },
    })
  ).data;
}

export default {
  get,
};
